import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SharedStyles.css';

interface SharedNavigationProps {
  title?: string;
}

const SharedNavigation: React.FC<SharedNavigationProps> = ({ title }) => {
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="app-nav">
      <nav className="app-nav-content">
        <Link to="/" className="app-logo" onClick={scrollToTop}>
          Pfändungstabelle API
        </Link>
        <div className="app-nav-links">
          <Link 
            to="/" 
            className={`app-nav-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={scrollToTop}
          >
            Startseite
          </Link>
          <Link 
            to="/support" 
            className={`app-nav-link ${location.pathname === '/support' ? 'active' : ''}`}
            onClick={scrollToTop}
          >
            Support
          </Link>
          <Link 
            to="/privacy" 
            className={`app-nav-link ${location.pathname === '/privacy' ? 'active' : ''}`}
            onClick={scrollToTop}
          >
            Datenschutz
          </Link>
          <Link 
            to="/terms" 
            className={`app-nav-link ${location.pathname === '/terms' ? 'active' : ''}`}
            onClick={scrollToTop}
          >
            AGB
          </Link>
          <Link 
            to="/imprint" 
            className={`app-nav-link ${location.pathname === '/imprint' ? 'active' : ''}`}
            onClick={scrollToTop}
          >
            Impressum
          </Link>
          <Link to="/login" className="app-nav-cta" onClick={scrollToTop}>
            Anmelden
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default SharedNavigation;
